import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import axios from 'axios';
import "./login.css";

import NavBar from "../../Layout/navbar";
import Footer from "../../Layout/footer";
import { getSocialLinksByEventId } from '../../../api/eventApi';
import { API_GATEWAY_URL, API_EVENT_USERS_URL_EMAIL } from '../../../config/constants';
import Home from '../home';
import { RootState } from '../../../store';

const VerifyEmail: React.FC = () => {
  const { email_token } = useParams<{ email_token: string }>();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading"); 
  const eventData: any = useSelector((state: RootState) => state.eventData);

  const [data, setData] = useState<any>();
  const [socialData, setSocialData] = useState<any>();
  const eventId = eventData?._id;

  // Email verification
  useEffect(() => {
    const verify = async () => {
      if (!email_token) {
        setStatus("error");
        return;
      }
      try {
        const decodeToken = decodeURI(email_token);
        await axios.post(`${API_EVENT_USERS_URL_EMAIL}event-user/verify-email`, {
          token: decodeToken,
        });
        setStatus("success");
      } catch (err) {
        setStatus("error");
      }
    };

    verify();
  }, [email_token]);

  // Landing page data
  useEffect(() => {
    const fetchData = async () => {
      if (!eventId) return;
      try {
        const res = await axios.get(`${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}`);
        setData(res.data.data);
      } catch (error) {
        console.error('Error fetching landing page data:', error);
      }
    };
    fetchData();
  }, [eventId]);

  return (
    <div>
      {/* Landing Page Header */}
      <div
        className="landingpage-wrapper"
        style={{
          backgroundColor: data?.landing_page_theme_color || "#ffffff",
        }}
      >
        <NavBar
          isSocialHeader={false}
          socialData={false}
          midSectionSettings={false}
        />
        {data && (
          <Home
            isVideo={false}
            image={false}
            video={false}
            isSpeakersVisible={false}
            isScheduleVisible={false}
            landingPageData={false}
          />
        )}
      </div>

      {/* Verification Status */}
      <div className="single-section about-area silver-bg" id="after-registration">
        <div className="container">
          <div className="row">
            <div className="verify-email-wrapper">
              <div className="verify-email-container">
                {status === "loading" && <p>Validating your information...</p>}
                {status === "success" && (
                  <div className="success-text">
                    <h2>Email Verified Successfully </h2>
                    <p>Thank you! Your email has been verified.</p>
                    <a href="/login" className="btn-primary">Go to Login</a>
                  </div>
                )}
                {status === "error" && (
                  <div className="error-text">
                    <h2>Verification Failed</h2>
                    <p>Your token is invalid or expired.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer
        isSocialFooter={data?.show_social_footer}
        socialData={socialData}
        show_partners_footer={data?.show_partners_footer}
        show_newsletter_footer={data?.show_newsletter_footer}
        data={data}
      />
    </div>
  );
};

export default VerifyEmail;
